import {
  CmBaseTable,
  CmSelect,
  CmTableBodyRow,
  CmTd,
  ThProps,
} from '@/components/uiParts';
import {
  ORDER_METHOD,
  OrderMethod,
  orderMethod,
} from '@/domain/models/Order/orderMethod';
import { DateDomainService } from '@/domain/services';
import { ommisionText } from '@/lib/util';
import { Coupon } from '@/pages/camel-order/coupons/index/types';

type Props = {
  coupons: Coupon[];
  handleStatusChange: (id: string, value: string) => void;
};

export const ACTIVE = 'ACTIVE';
export const INACTIVE = 'INACTIVE';
export const DELETED = 'DELETED';

export const CouponTable: React.FC<Props> = ({
  coupons,
  handleStatusChange,
}) => {
  const itemTableThs: ThProps[] = [
    {
      label: 'クーポン名',
      minWidth: '200px',
      position: 'left',
    },
    {
      label: 'クーポンコード',
      minWidth: '200px',
      position: 'left',
    },
    {
      label: '割引額',
      minWidth: '120px',
      position: 'left',
    },
    {
      label: '最低購入金額',
      minWidth: '120px',
      position: 'left',
    },
    {
      label: '有効期間',
      minWidth: '120px',
      position: 'center',
    },
    {
      label: '利用された回数',
      minWidth: '120px',
      position: 'left',
    },
    {
      label: 'ユーザー毎の利用上限回数',
      minWidth: '120px',
      position: 'left',
    },
    {
      label: '売上',
      minWidth: '140px',
      position: 'left',
    },
    {
      label: '値引き額合計',
      minWidth: '140px',
      position: 'left',
    },
    {
      label: 'ステータス',
      minWidth: '100px',
      position: 'center',
    },
    {
      label: '対象の注文方式',
      minWidth: '100px',
      position: 'center',
    },
    {
      label: '最終更新日時',
      minWidth: '100px',
      position: 'center',
    },
    {
      label: 'アクション',
      minWidth: '120px',
      position: 'center',
    },
  ];

  return (
    <CmBaseTable ths={itemTableThs}>
      {coupons.map((coupon) => {
        // 有効期間
        const ValidRange =
          coupon.valid_from == undefined && coupon.valid_to == undefined ? (
            <>-</>
          ) : (
            <>
              {coupon.valid_from
                ? `${DateDomainService.formatDay(
                    DateDomainService.parseISOFormat(coupon.valid_from)
                  )} -`
                : '-'}
              <br />
              {coupon.valid_to
                ? DateDomainService.formatDay(
                    DateDomainService.parseISOFormat(coupon.valid_to)
                  )
                : ''}
            </>
          );
        const minimalOrderValue =
          coupon.condition_type === 'MINIMAL_ORDER_VALUE'
            ? coupon.condition_value ?? '0'
            : '-';
        const max_usage_per_user =
          coupon.max_usage_per_user == null ? '-' : coupon.max_usage_per_user;
        const status = coupon.status === ACTIVE ? '有効' : '無効';
        const updatedAt = DateDomainService.datetimeFormat(
          new Date(coupon.updated_at)
        );

        const availableOrderMethods: OrderMethod[] = [];
        if (coupon.delivery) availableOrderMethods.push(ORDER_METHOD.DELIVERY);
        if (coupon.eatin) availableOrderMethods.push(ORDER_METHOD.EAT_IN);
        if (coupon.takeout) availableOrderMethods.push(ORDER_METHOD.TAKE_OUT);
        const availableOrderMethodsText = availableOrderMethods
          .map((m) => orderMethod[m])
          .join(', ');

        return (
          <CmTableBodyRow key={coupon.id}>
            <CmTd>{ommisionText(coupon.name, 20)}</CmTd>
            <CmTd>{ommisionText(coupon.code, 20)}</CmTd>
            <CmTd>{coupon.discount}</CmTd>
            <CmTd>{minimalOrderValue}</CmTd>
            <CmTd textAlign="center">{ValidRange}</CmTd>
            <CmTd>{coupon.used_times}</CmTd>
            <CmTd>{max_usage_per_user}</CmTd>
            <CmTd>{coupon.sales}</CmTd>
            <CmTd>{coupon.discount_amount_sum}</CmTd>
            <CmTd textAlign="center">{status}</CmTd>
            <CmTd>{availableOrderMethodsText}</CmTd>
            <CmTd textAlign="center">{updatedAt}</CmTd>
            <CmTd textAlign="center">
              <CmSelect
                size="sm"
                value={'unselectable'}
                onChange={(e) => handleStatusChange(coupon.id, e.target.value)}
              >
                <option value="unselectable" disabled>
                  アクション
                </option>
                <option value={ACTIVE}>有効</option>
                <option value={INACTIVE}>無効</option>
                <option value={DELETED}>削除</option>
              </CmSelect>
            </CmTd>
          </CmTableBodyRow>
        );
      })}
    </CmBaseTable>
  );
};
